<div class="col-sm-12 text-center section-b-space mt-5 no-found">
    <img [src]="loadGif" class="img-fluid mb-4">
    <p>Cargando contenido</p>
</div>
